<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="text-white bg-blue" inline-actions>
        سفارش
        <q-badge align="top" color="indigo" class="q-ml-xs">{{ orderInfo.Buy_Num }}</q-badge>
        <q-badge align="top" label="برگشتی" v-if="orderInfo.Buy_Kind===-1" color="red" text-color="white"
                 class="q-ml-xs"/>
        <template v-slot:action>
          <q-btn icon="close" v-close-popup flat round v-if="!issueFactor"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="text-center no-padding">
      <q-chip color="indigo" text-color="white" square v-for="(item,index) in groupedList" :key="index"
              :label="item.Group_Name">
        <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`${item.sum.toLocaleString()} ریال`"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding" v-if="issueFactor">
      <div class="row flex flex-center">
        <div class="col-xs-2">
          <q-input dir="ltr" v-model="tax" label="مالیات ارزش فزوده" filled/>
        </div>
      </div>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="OrderDetailsList"
          row-key="Goods_ID"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :hide-bottom="!$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">کد کالا</td>
            <td class="text-center">نام کالا</td>
            <td class="text-center">تعداد</td>
            <td class="text-center">واحد</td>
            <td class="text-center">قیمت واحد</td>
            <td class="text-center">قیمت کل</td>
            <td class="text-center" v-if="issueFactor">مالیات و ارزش افزوده</td>
            <td class="text-center">تخفیف</td>
          </q-tr>
          <q-tr class="bg-indigo text-white text-center">
            <td>{{ OrderDetailsList.length }} قلم</td>
            <td></td>
            <td>{{ lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count)) }}</td>
            <td></td>
            <td></td>
            <td>
              {{ isBuyRequest ? undefined : lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_PricePure)).toLocaleString() }}
            </td>
            <td v-if="issueFactor">
              {{ lodash.sumBy(OrderDetailsList, item => parseInt(item.SaleG_Tax)).toLocaleString() }}
            </td>
            <td>
              {{
                isBuyRequest ? undefined : lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_Off)).toLocaleString()
              }}
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center">
            <td>
              <q-btn icon="delete" flat round color="red-10" @click="deleteItem(props.row)"/>
              <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                      v-if="props.row.Goods_Code!=='109991'" color="indigo" text-color="white"
                      :label="props.row.Goods_Code"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-chip square dense :label="props.row.Group_Name"/>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991' && !issueFactor">
                {{ props.row.SaleG_Count }}
              </q-badge>
              <q-input clearable dir="ltr" v-model="props.row.SaleG_Count" v-if="issueFactor" filled/>
            </td>
            <td>
              <q-chip square color="brown" text-color="white" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.Unit_Name }}
              </q-chip>
            </td>
            <td>
              <q-field
                  v-if="issueFactor"
                  v-model="props.row.SaleG_PricePure"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
              </q-field>
              <q-chip text-color="white" square color="teal" class="q-ml-xs" v-if="!issueFactor && !isBuyRequest">
                <span >
                  {{ props.row.SaleG_PricePure | toLoalString }}
                ریال</span>
              </q-chip>
            </td>
            <td>
              <q-chip text-color="white" v-if="!isBuyRequest" square color="teal-14" class="q-ml-xs">
                <span>
                  {{ (props.row.SaleG_Count * props.row.SaleG_PricePure) | toLoalString }}
                  ریال
                </span>
              </q-chip>
            </td>
            <td class="text-center" v-if="issueFactor && !isBuyRequest">
              <q-field
                  v-model="props.row.SaleG_Tax"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
                <template v-slot:append>
                  <q-btn icon="attach_money" flat round padding="none" @click="computeTax(props.row)">
                    <q-tooltip>
                      محاسبه مالیات
                    </q-tooltip>
                  </q-btn>
                </template>
              </q-field>
            </td>
            <td v-if="props.row.Goods_Code!=='109991'">
              <q-field
                  v-if="issueFactor"
                  v-model="props.row.SaleG_Off_D"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  @input="computeSaleGOff(props.row)"
                  dense
                  clearable
                  label="درصد تخفیف"
                  lazy-rules>
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value)"
                         type="number"
                         v-show="floatingLabel">
                </template>

              </q-field>
              <q-field
                  class="q-mt-xs"
                  v-if="issueFactor"
                  v-model="props.row.SaleG_Off"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ تخفیف خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ تخفیف خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>

              </q-field>
              <q-chip square color="red" v-if="!issueFactor && !isBuyRequest" text-color="white"
                      :label="`${props.row.SaleG_Off} %`"/>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-card-section v-if="issueFactor" align="center">
      <div class="row">
        <div class="col col-md-2 offset-5">
          <q-field
              v-if="issueFactor"
              v-model="totalOff"
              mask="currency"
              label="تخفیف کل"
              label-color="indigo"
              autofocus
              dir="ltr"
              filled
              dense
              clearable
              lazy-rules
              :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'تخفیف کل خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تخفیف کل خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
            <template v-slot:control="{ id, floatingLabel, value, emitValue }">
              <input :id="id" class="q-field__native text-right" :value="value"
                     @change="e => emitValue(e.target.value.replaceAll(',',''))"
                     v-money="moneyFormatForDirective"
                     v-show="floatingLabel">
            </template>
          </q-field>
          <q-field
              v-if="issueFactor"
              v-model="transportCost"
              mask="currency"
              label="کرایه حمل بار"
              label-color="indigo"
              autofocus
              dir="ltr"
              filled
              dense
              clearable
              lazy-rules
              :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'تخفیف کل خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تخفیف کل خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
            <template v-slot:control="{ id, floatingLabel, value, emitValue }">
              <input :id="id" class="q-field__native text-right" :value="value"
                     @change="e => emitValue(e.target.value.replaceAll(',',''))"
                     v-money="moneyFormatForDirective"
                     v-show="floatingLabel">
            </template>
          </q-field>
        </div>
      </div>
    </q-card-section>
    <q-card-actions align="center" v-if="issueFactor">
      <q-btn label="صدور فاکتور" @click="issueFactorData" color="primary" icon="check"/>
      <q-btn flat label="انصراف" color="red" icon="cancel" @click="$emit('cancel-dialog')"/>
    </q-card-actions>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "BuyOrderDetailsDesktop",
  components: {ProductDetail},
  props: {
    orderInfo: {
      type: Object
    },
    issueFactor: {
      type: Boolean,
      default: false
    },
    isBuyRequest: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      groupedList: [],
      tax: 0,
      transportCost: 0,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      totalOff: 0,
      selectedProductDetails: [],
      showProductDetails: false,
      selectedCustomer: '',
      OrderDetailsList: [],
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Buys/getOrderDetails',
      getCustomerInfo: 'Customers/get_customer_info',
      getProductInfo: 'Products/getProductInfo',
      generateFactor: 'Buys/upsertFactor',
      deleteOrderItem: 'Buys/deleteOrderItem'
    }),
    computeSaleGOff(orderItemInfo) {
      orderItemInfo.SaleG_Off = Math.round(parseInt(orderItemInfo.SaleG_PricePure) * (orderItemInfo.SaleG_Off_D / 100))
    },
    deleteItem(itemInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'کالا حذف شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteOrderItem(
            {
              BuyNum: itemInfo.Buy_Num,
              BuyKind: itemInfo.Buy_Kind,
              GoodsID: itemInfo.Goods_ID
            }).then(() => {
          const founded = this.OrderDetailsList.findIndex(item => item.Goods_ID === itemInfo.Goods_ID)
          this.$delete(this.OrderDetailsList, founded)
        })
      })
    },
    computeTax(orderItemInfo) {
      orderItemInfo.SaleG_Tax = (orderItemInfo.SaleG_PricePure * this.tax) / 100.00
      orderItemInfo.SaleG_Tax_D = this.tax;
    },
    issueFactorData() {
      const sendObject = {
        Factor_Num: 'NULL',
        Buy_Num: this.orderInfo.Buy_Num,
        Buy_Kind: this.orderInfo.Buy_Kind,
        items: this.OrderDetailsList,
        transportCost: this.transportCost,
        totalOff: this.totalOff
      }
      this.generateFactor(sendObject).then((res) => {
        if (res[0].BuyNum !== undefined) {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position: 'top',
            message: `فاکتور خرید به شماره ${res[0].BuyNum} ثبت گردید`
          })
          this.$emit('generated-factory', res)
        } else {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            position: 'top',
            message: 'خطا در صدور فاکتور'
          })
        }
      });
    },
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
  },
  watch: {
    tax: function (value) {
      if (!isNaN(value)) {
        this.OrderDetailsList.forEach(item => {
          item.SaleG_Tax = item.SaleG_Count * Math.round(((item.SaleG_PricePure * this.tax) / 100.00))
          item.SaleG_Tax_D = this.tax;

        })
      }
    }
  },
  created() {
    this.getDetails({buyNum: this.orderInfo.Buy_Num, buyKind: this.orderInfo.Buy_Kind}).then((res) => {
      this.OrderDetailsList = res
      this.groupedList = this.lodash(this.OrderDetailsList).filter(item => item.Goods_Group !== 86).groupBy('Group_Name')
          .map(function (items, Group_Name) {
            return {
              Group_Name: Group_Name,
              sum: items.map(item => item.SaleG_TotalAll).reduce((accumulator, curr) => accumulator + curr),
            };
          }).value();
    });
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
